import useChangeTracking from "./useChangeTracking";
import PropTypes from "prop-types";
import styles from "./index.css";

const FulfilmentChangeNotification = ({ source, seller }) => {
  const sellerChange = useChangeTracking({ source, seller });

  return (
    <span aria-live="polite" className={styles.screenReaderOnly}>
      {sellerChange}
    </span>
  );
};

FulfilmentChangeNotification.propTypes = {
  source: PropTypes.shape({
    description: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }),
  seller: PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
};

export default FulfilmentChangeNotification;
